module.exports = __webpack_public_path__ + "img/assist.60dcf45d.png";